import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PipelineStepConfig, PipelineStepRunState, ContentTemplate } from '../../types';

@Component({
    standalone: false,
    selector: 'mkt-pipeline-step-card',
    templateUrl: './pipeline-step-card.component.html',
    styleUrls: ['./pipeline-step-card.component.css'],
})
export class PipelineStepCardComponent {
    @Input() step!: PipelineStepConfig;
    @Input() stepIndex: number = 0;
    @Input() totalSteps: number = 0;
    @Input() expanded: boolean = false;
    @Input() runState: PipelineStepRunState | null = null;
    @Input() contentTemplates: ContentTemplate[] = [];
    @Input() disabled: boolean = false;

    @Output() expandToggle = new EventEmitter<void>();
    @Output() remove = new EventEmitter<void>();
    @Output() moveUp = new EventEmitter<void>();
    @Output() moveDown = new EventEmitter<void>();
    @Output() instructionsChanged = new EventEmitter<string>();
    @Output() templateBodyChanged = new EventEmitter<string>();

    showTemplateEditor = false;
    editedTemplateBody = '';

    get instructionsHint(): string {
        return `Custom instructions for the ${this.step.displayName} step...`;
    }

    get statusLabel(): string {
        if (!this.runState) return 'idle';
        return this.runState.status;
    }

    get matchingTemplate(): ContentTemplate | null {
        if (!this.step.templateType) return null;
        return this.contentTemplates.find(t =>
            t.TemplateType === this.step.templateType && t.IsActive
        ) || null;
    }

    get elapsed(): string {
        if (!this.runState?.startedAt) return '';
        const end = this.runState.completedAt || new Date();
        const ms = end.getTime() - this.runState.startedAt.getTime();
        const s = Math.floor(ms / 1000);
        if (s < 60) return `${s}s`;
        return `${Math.floor(s / 60)}m ${s % 60}s`;
    }

    onInstructionsInput(value: string): void {
        this.instructionsChanged.emit(value);
    }

    toggleTemplateEditor(): void {
        if (!this.showTemplateEditor && this.matchingTemplate) {
            this.editedTemplateBody = this.matchingTemplate.TemplateBody || '';
        }
        this.showTemplateEditor = !this.showTemplateEditor;
    }

    onTemplateSave(): void {
        this.templateBodyChanged.emit(this.editedTemplateBody);
        this.showTemplateEditor = false;
    }
}
